import { array, record } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { getProp, getStringProp, values } from '@mews/fp';
import { parentSelector } from '../../selectors/parentSelector';
import { OccupancyData } from '../resourceOrder/occupancyTypes';
import { getServicePricingHash } from './utils';

const getServicePricing = createSelector(parentSelector, (state) => state.data.servicePricing);
const getServicePricingMeta = createSelector(getServicePricing, (servicePricing) => servicePricing.meta);

const getServiceCategoriesPricingHash = createSelector(
    getStringProp('currencyCode'),
    getStringProp('endUtc'),
    getStringProp('startUtc'),
    getStringProp('serviceId'),
    getStringProp('enterpriseId'),
    getProp<string | undefined>()('voucherCode'),
    getProp<Array<OccupancyData>>()('occupancyData'),
    (currencyCode, endUtc, startUtc, serviceId, enterpriseId, voucherCode, occupancyData) =>
        getServicePricingHash({
            serviceId,
            startUtc,
            voucherCode,
            currencyCode,
            endUtc,
            enterpriseId,
            occupancyData,
        })
);

export const getServiceCategoriesPricingMeta = createSelector(
    getServiceCategoriesPricingHash,
    getServicePricingMeta,
    (servicePricingHash, servicePricingMeta) => pipe(servicePricingMeta, record.lookup(servicePricingHash))
);

export const isAnyServicePricingFetching = createSelector(
    getServicePricingMeta,
    flow(
        values,
        array.some((pricing) => pricing.isFetching)
    )
);

export const hasAnyServicePricingFailed = createSelector(
    getServicePricingMeta,
    flow(
        values,
        array.some((pricing) => pricing.hasFailed)
    )
);
